module.exports = __webpack_public_path__ + "static/media/06.5f9271f9.mp3";